import React from "react";
import PageHero from "./PageHero";

const AboutHeading = () => {
  return (
    <PageHero
      title="About Us"
      subtitle="Transforming metals into masterpieces since 1998. Learn about our journey, values, and commitment to excellence."
      backgroundImage="./assets/welding.jpeg"
      breadcrumbs={[{ label: "About Us" }]}
    />
  );
};

export default AboutHeading;
